module.exports = __webpack_public_path__ + "static/media/PFDinTextPro-Regular.5b580d62.woff";